import { z } from 'zod';

/** A role holder's name as an entity's description carries it (CREATURE-NAMED). */
export const HolderNameSchema = z.object({
  n: z.string().min(1).max(24),
  r: z.string().min(1).max(32),
  p: z.string().min(1).max(32),
  b: z.number().int().min(0).max(63).optional(),
  f: z.literal(true).optional(),
  o: z.number().int().min(2).max(99).optional(),
});
export type HolderName = z.infer<typeof HolderNameSchema>;
